import { render, staticRenderFns } from "./RoleItem.vue?vue&type=template&id=4414c332&"
import script from "./RoleItem.vue?vue&type=script&lang=js&"
export * from "./RoleItem.vue?vue&type=script&lang=js&"
import style0 from "./RoleItem.vue?vue&type=style&index=0&id=4414c332&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports